const APP_STORE_URL = "https://apps.apple.com/gb/app/kindred-community/id6760599593";

type AppStoreBadgeProps = {
  loading?: "eager" | "lazy";
};

export default function AppStoreBadge({ loading = "lazy" }: AppStoreBadgeProps) {
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Download Kindred on the App Store"
      className="inline-flex rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#6b3566]"
    >
      <img
        src="/download-on-the-app-store.svg"
        alt="Download on the App Store"
        className="h-12 w-auto"
        loading={loading}
      />
    </a>
  );
}
